var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDaiLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y1: 1.142,
    y2: -0.105,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbcc5f"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#a)",
    "data-name": "Ellipse 1271"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.825 20.875h-2.967c-1.633-4.533-6.025-7.642-11.817-7.642h-9.525v7.642h-3.308v2.742h3.308v2.875h-3.308v2.741h3.308v7.55h9.525c5.725 0 10.083-3.083 11.758-7.55h3.025v-2.742h-2.358a12.433 12.433 0 0 0 .092-1.483v-.067c0-.45-.025-.892-.067-1.325h2.342v-2.742zm-21.642-5.2h6.858c4.25 0 7.408 2.092 8.867 5.192H18.183zm6.858 18.642h-6.858v-5.092h15.708c-1.466 3.05-4.616 5.091-8.85 5.091zm9.758-9.25a9.859 9.859 0 0 1-.1 1.417H18.183v-2.875h16.525a10.84 10.84 0 0 1 .092 1.392z",
    "data-name": "Path 7536"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaiLogo);
export default __webpack_public_path__ + "static/media/dai-logo.6ab7f07d0d2a0ac5e4fdde8d53d82c7e.svg";
export { ForwardRef as ReactComponent };